// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --swiper-theme-color: #2D9C4B !important;
}

.student-box{
    background-color: white;
    box-shadow: 0 0 10px rgba(0,0,0,0.25);
    border-radius: 20px;
}


.homework-box{
    background-color: rgba(175, 175, 175, 0.207);
    border-radius: 10px;
    border:1px solid rgba(0,0,0,0.25);
    padding: 15px 0;
}

.arrow1{
    position: absolute;
    top:40px;
    right: 125px;
}

.arrow2{
    position: absolute;
    top:40px;
    right: 250px;
}

.table>:not(caption)>*>*{
    box-shadow: none;
}

.table{
    border-color: transparent !important;
}

.table>thead{
    border-bottom-color: rgba(175, 175, 175, 0.207);
    margin-bottom:20px !important;
   
}


tr td {
    height: 30px;
    line-height: 30px; /* برابر با height برای متن‌های تک خطی */
    vertical-align: middle;
    font-size: 15px;
   font-weight: lighter;
}

th{
    font-size: 15px;
}

.card-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin: 20px;
}

.card {
    width: 300px;
    border: 1px solid #ddd;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.card img {
    width: 100%;
    height: auto;
}

.chevron-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #333;
    padding: 10px;
}

.chevron-btn:hover {
    color: #007bff;
}

.custom-pagination {
  direction: rtl;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  font-family: "IRANSans", sans-serif;
}

.custom-pagination .page-item {
  border: none;
}

.custom-pagination .page-link {
  color: #3672C4;
  border: none;
  background-color: transparent;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.custom-pagination .page-item.active .page-link {
  background-color: #2D9C4B;
  color: white;
  z-index: 1;
}

.custom-pagination .page-link:focus {
  box-shadow: none;
}

.custom-pagination .page-item.disabled .page-link {
  color: #aaa;
}

.custom-pagination {
  direction: rtl;
  display: flex;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
}

.custom-pagination .page-item .page-link {
  background: transparent;
  border: none;
  color: #2D9C4B;
  font-size: 16px;
  padding: 6px 12px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.custom-pagination .page-item.active .page-link {
  background-color: #2D9C4B;
  color: #fff;
}

.custom-pagination .page-item.disabled .page-link {
  color: #999;
}

.custom-pagination .page-link:hover {
  background-color: rgba(45, 156, 75, 0.1);
}


 ul{
    margin-bottom: 0 !important;
 }


@media (min-width:420px) and (max-width:990px) {
  .map {
    width: 380px;
  
  }
  .my-map{
    display: flex;
    justify-content: center;
  }
}


/* container که overflow-x: auto داره */
.nowrap {
  overflow-x: auto;        /* فعال کردن اسکرول افقی */
  scrollbar-width: none;   /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

/* برای Chrome, Safari, Opera */
.nowrap::-webkit-scrollbar {
  width: 0px;
  height: 0px;             /* برای اسکرول افقی */
  background: transparent;  /* فقط برای اطمینان */
}


.gohomework{
  font-size: 15px;
  border: none;
  outline: none;
  background-color: rgba(25, 118, 210, 1);
  color: white;
  padding:5px 10px;
  border-radius: 10px;
  margin-bottom:10px  ;
}

.course-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 150px;
}


.mlogo-container {
    background-color: #F3F3F3;
    padding:0 10px;
    padding-bottom: 25px;
    border-radius: 15px;
    position: relative;
    width: 130px;
}

.course-link {
    width: 100%;
    border-radius: 20px;
    background-color: #3672C4;
    border:.5px solid #3672C4;
    color: #FFFFFF;
    position: absolute;
    right: 0px;
    bottom: 0px;
    display: flex;
    font-size: 13px;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    padding: 5px;
}

.swiper-button-prev, .swiper-button-next {
    svg{
      width: 60% !important;
      height: 60% !important;
    }
  }

  .student-box table {
  table-layout: auto !important; /* بر اساس محتوا اندازه بده */
         /* نذار خودش بکشه همه عرض رو */
  min-width: 100%;              /* حداقل اندازه، نه اجباری */
  white-space: nowrap;          /* نذار چیزی بره خط بعد */
}


.table-responsive::-webkit-scrollbar {
    height: 8px;           
           
}


.table-responsive::-webkit-scrollbar-thumb {
    background-color: #2D9C4B;   
    border-radius: 10px;       
}

.message-number{
  position: absolute;
  top: -15px;
  right: 10px;
  background-color: #FB0303;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  color: white;
  border-radius: 100%;
}
.all-pic {
  width: 100%;
  height: 200px;
  overflow: hidden;
border-radius: 20px 20px 0 0 ;
}

.all-pic .img23 {
  width: 100%;
  height: 100%;
  object-fit: cover; /* تصویر کل فضا را پر می‌کند، بدون کشیدگی */
  display: block;
}

@media (max-width: 480px) {
.bb-none{
  border-bottom: 1px solid #e1e1e1;
}
}

.not-buy{
  background-color: white;

  border-radius:  0 0 20px 20px;
}


.custom-pagination {
  direction: rtl;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  font-family: "IRANSans", sans-serif;
}

.custom-pagination .page-item {
  border: none;
}

.custom-pagination .page-link {
  color: #3672C4;
  border: none;
  background-color: transparent;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.custom-pagination .page-item.active .page-link {
  background-color: #2D9C4B;
  color: white;
  z-index: 1;
}

.custom-pagination .page-link:focus {
  box-shadow: none;
}

.custom-pagination .page-item.disabled .page-link {
  color: #aaa;
}

.custom-pagination {
  direction: rtl;
  display: flex;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
}

.custom-pagination .page-item .page-link {
  background: transparent;
  border: none;
  color: #2D9C4B;
  font-size: 16px;
  padding: 6px 12px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.custom-pagination .page-item.active .page-link {
  background-color: #2D9C4B;
  color: #fff;
}

.custom-pagination .page-item.disabled .page-link {
  color: #999;
}

.custom-pagination .page-link:hover {
  background-color: rgba(45, 156, 75, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,mBAAmB;AACvB;;;AAGA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+CAA+C;IAC/C,6BAA6B;;AAEjC;;;AAGA;IACI,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;IAC3D,sBAAsB;IACtB,eAAe;GAChB,oBAAoB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;;CAGC;IACG,2BAA2B;CAC9B;;;AAGD;EACE;IACE,YAAY;;EAEd;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;;;AAGA,uCAAuC;AACvC;EACE,gBAAgB,SAAS,0BAA0B;EACnD,qBAAqB,IAAI,YAAY;EACrC,wBAAwB,EAAE,WAAW;AACvC;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,WAAW,cAAc,qBAAqB;EAC9C,uBAAuB,GAAG,qBAAqB;AACjD;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;MACE,qBAAqB;MACrB,sBAAsB;IACxB;EACF;;EAEA;EACA,6BAA6B,EAAE,6BAA6B;SACrD,8BAA8B;EACrC,eAAe,eAAe,4BAA4B;EAC1D,mBAAmB,WAAW,yBAAyB;AACzD;;;AAGA;IACI,WAAW;;AAEf;;;AAGA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB,6BAA6B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,2CAA2C;EAC9D,cAAc;AAChB;;AAEA;AACA;EACE,gCAAgC;AAClC;AACA;;AAEA;EACE,uBAAuB;;EAEvB,6BAA6B;AAC/B;;;AAGA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[":root {\n    --swiper-theme-color: #2D9C4B !important;\n}\n\n.student-box{\n    background-color: white;\n    box-shadow: 0 0 10px rgba(0,0,0,0.25);\n    border-radius: 20px;\n}\n\n\n.homework-box{\n    background-color: rgba(175, 175, 175, 0.207);\n    border-radius: 10px;\n    border:1px solid rgba(0,0,0,0.25);\n    padding: 15px 0;\n}\n\n.arrow1{\n    position: absolute;\n    top:40px;\n    right: 125px;\n}\n\n.arrow2{\n    position: absolute;\n    top:40px;\n    right: 250px;\n}\n\n.table>:not(caption)>*>*{\n    box-shadow: none;\n}\n\n.table{\n    border-color: transparent !important;\n}\n\n.table>thead{\n    border-bottom-color: rgba(175, 175, 175, 0.207);\n    margin-bottom:20px !important;\n   \n}\n\n\ntr td {\n    height: 30px;\n    line-height: 30px; /* برابر با height برای متن‌های تک خطی */\n    vertical-align: middle;\n    font-size: 15px;\n   font-weight: lighter;\n}\n\nth{\n    font-size: 15px;\n}\n\n.card-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    margin: 20px;\n}\n\n.card {\n    width: 300px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-align: center;\n}\n\n.card img {\n    width: 100%;\n    height: auto;\n}\n\n.chevron-btn {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #333;\n    padding: 10px;\n}\n\n.chevron-btn:hover {\n    color: #007bff;\n}\n\n.custom-pagination {\n  direction: rtl;\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  font-family: \"IRANSans\", sans-serif;\n}\n\n.custom-pagination .page-item {\n  border: none;\n}\n\n.custom-pagination .page-link {\n  color: #3672C4;\n  border: none;\n  background-color: transparent;\n  font-size: 16px;\n  padding: 8px 12px;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: #2D9C4B;\n  color: white;\n  z-index: 1;\n}\n\n.custom-pagination .page-link:focus {\n  box-shadow: none;\n}\n\n.custom-pagination .page-item.disabled .page-link {\n  color: #aaa;\n}\n\n.custom-pagination {\n  direction: rtl;\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  font-family: inherit;\n}\n\n.custom-pagination .page-item .page-link {\n  background: transparent;\n  border: none;\n  color: #2D9C4B;\n  font-size: 16px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  transition: background-color 0.3s ease;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: #2D9C4B;\n  color: #fff;\n}\n\n.custom-pagination .page-item.disabled .page-link {\n  color: #999;\n}\n\n.custom-pagination .page-link:hover {\n  background-color: rgba(45, 156, 75, 0.1);\n}\n\n\n ul{\n    margin-bottom: 0 !important;\n }\n\n\n@media (min-width:420px) and (max-width:990px) {\n  .map {\n    width: 380px;\n  \n  }\n  .my-map{\n    display: flex;\n    justify-content: center;\n  }\n}\n\n\n/* container که overflow-x: auto داره */\n.nowrap {\n  overflow-x: auto;        /* فعال کردن اسکرول افقی */\n  scrollbar-width: none;   /* Firefox */\n  -ms-overflow-style: none; /* IE 10+ */\n}\n\n/* برای Chrome, Safari, Opera */\n.nowrap::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;             /* برای اسکرول افقی */\n  background: transparent;  /* فقط برای اطمینان */\n}\n\n\n.gohomework{\n  font-size: 15px;\n  border: none;\n  outline: none;\n  background-color: rgba(25, 118, 210, 1);\n  color: white;\n  padding:5px 10px;\n  border-radius: 10px;\n  margin-bottom:10px  ;\n}\n\n.course-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 140px;\n    height: 150px;\n}\n\n\n.mlogo-container {\n    background-color: #F3F3F3;\n    padding:0 10px;\n    padding-bottom: 25px;\n    border-radius: 15px;\n    position: relative;\n    width: 130px;\n}\n\n.course-link {\n    width: 100%;\n    border-radius: 20px;\n    background-color: #3672C4;\n    border:.5px solid #3672C4;\n    color: #FFFFFF;\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n    display: flex;\n    font-size: 13px;\n    text-decoration: none;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n}\n\n.swiper-button-prev, .swiper-button-next {\n    svg{\n      width: 60% !important;\n      height: 60% !important;\n    }\n  }\n\n  .student-box table {\n  table-layout: auto !important; /* بر اساس محتوا اندازه بده */\n         /* نذار خودش بکشه همه عرض رو */\n  min-width: 100%;              /* حداقل اندازه، نه اجباری */\n  white-space: nowrap;          /* نذار چیزی بره خط بعد */\n}\n\n\n.table-responsive::-webkit-scrollbar {\n    height: 8px;           \n           \n}\n\n\n.table-responsive::-webkit-scrollbar-thumb {\n    background-color: #2D9C4B;   \n    border-radius: 10px;       \n}\n\n.message-number{\n  position: absolute;\n  top: -15px;\n  right: 10px;\n  background-color: #FB0303;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  color: white;\n  border-radius: 100%;\n}\n.all-pic {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\nborder-radius: 20px 20px 0 0 ;\n}\n\n.all-pic .img23 {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* تصویر کل فضا را پر می‌کند، بدون کشیدگی */\n  display: block;\n}\n\n@media (max-width: 480px) {\n.bb-none{\n  border-bottom: 1px solid #e1e1e1;\n}\n}\n\n.not-buy{\n  background-color: white;\n\n  border-radius:  0 0 20px 20px;\n}\n\n\n.custom-pagination {\n  direction: rtl;\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  font-family: \"IRANSans\", sans-serif;\n}\n\n.custom-pagination .page-item {\n  border: none;\n}\n\n.custom-pagination .page-link {\n  color: #3672C4;\n  border: none;\n  background-color: transparent;\n  font-size: 16px;\n  padding: 8px 12px;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: #2D9C4B;\n  color: white;\n  z-index: 1;\n}\n\n.custom-pagination .page-link:focus {\n  box-shadow: none;\n}\n\n.custom-pagination .page-item.disabled .page-link {\n  color: #aaa;\n}\n\n.custom-pagination {\n  direction: rtl;\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  font-family: inherit;\n}\n\n.custom-pagination .page-item .page-link {\n  background: transparent;\n  border: none;\n  color: #2D9C4B;\n  font-size: 16px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  transition: background-color 0.3s ease;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: #2D9C4B;\n  color: #fff;\n}\n\n.custom-pagination .page-item.disabled .page-link {\n  color: #999;\n}\n\n.custom-pagination .page-link:hover {\n  background-color: rgba(45, 156, 75, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
